import React, { useEffect, useRef, useState, useMemo } from "react";
import CustomInput from "../utils/Input";
import CustomButton from "../utils/Button";
import customParseFormat from "dayjs/plugin/customParseFormat";
import CloseIcon from "@mui/icons-material/Close";
import { fabricationMachines, printingMachines } from "../enums/vendorMachines";
import { Close, Delete, RepeatOneSharp } from "@mui/icons-material";
import { PlusIcon } from "../assets/icons";
import CancelIcon from "@mui/icons-material/Cancel";
import Spinner from "../../../src/shared/assets/icons/Spinner.jsx";
import getAddressLatLong from "../utils/getAddressLatLong.js";

import dayjs from "dayjs";
import Box from "@mui/material/Box";

import CapitalizeFirstLetter from "../utils/CapitalizeFirstLetter";
import ClientDropdown from "./ClientDropdown";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ClientOnboarding from "./ClientOnboarding";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  Alert,
  Chip,
  CircularProgress,
  FormHelperText,
  Grid,
  IconButton,
  Snackbar,
  Stack,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Modal,
  ListItemText,
  Tooltip,
  FormControlLabel,
  Typography,
  FormGroup,
  Radio,
  RadioGroup,
  InputLabel,
  FormLabel,
  Menu,
} from "@mui/material";

import {
  AuditIcon,
  Cross,
  Delivery,
  InstalliationIcons,
  Recce,
  Search,
  Trash,
  ViewIcon,
} from "../assets/icons";
import axios from "axios";
import Manufacturing from "../assets/icons/Manufacturing";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { combinedCategories } from "../enums/productsList";
import { handleFileUploadForLocations } from "../../components/AdminportalFolder/RFP/uploadExcelSheetForUploadingLocations";
import StoreMapping from "../../components/AdminportalFolder/Campaign/StoreMapping";
import ProductStoreMapping from "../../components/AdminportalFolder/Campaign/ProductStoreMapping";
import ExtractDataFromExcel from "../utils/ExtractDataFromExcel";
import GlobalSnackbar from "../utils/GlobalSnackbar";
import CostCalculator from "../../components/AdminportalFolder/CostCalculator";
import StateAccordion from "./StateAccordion .js";
import CityAccordion from "./CityAccordion.js";
import ProductTabs from "./ProductTabs";
import ServiceNeeded from "./ServiceNeeded";
import GlobalDropdownField from "../utils/GlobalDropdownField";
import ReportsMainModal from "./ReportsMainModal";
import { PRODUCT_TYPES } from "../../shared/enums/productTypeList";
import FabricationMachinesDetails from "./FabricationMachinesDetails.jsx";
import PrintingMachineDetails from "./PrintingMachineDetails.jsx";
import EnquiryHeader from "./EnquiryHeader.jsx";
import GlobalButton from "../utils/GlobalButton.jsx";

dayjs.extend(customParseFormat);

const printMachine = [
  { type: "Solvent Printing" },
  { type: "Ecosolvent Printing" },
  { type: "UV Printing" },
  { type: "Latex Printing" },
  { type: "Plotter Cutting Printing" },
  { type: "Digital Printing" },
];

const machineForPrinting = [
  {
    type: "Solvent Printing",
    details: {
      machinePrintingSubType: "",
      picoliter: "",
      machineBrand: "",
      maxPrintSize: "",
      ageOfMachine: "",
    },
    checked: false,
  },
  {
    type: "Ecosolvent Printing",
    details: {
      machinePrintingSubType: "",
      picoliter: "",
      machineBrand: "",
      maxPrintSize: "",
      ageOfMachine: "",
    },
    checked: false,
  },
  {
    type: "UV Printing",
    details: {
      machinePrintingSubType: "",
      picoliter: "",
      machineBrand: "",
      maxPrintSize: "",
      ageOfMachine: "",
    },
    checked: false,
  },
  {
    type: "Latex Printing",
    details: {
      machinePrintingSubType: "",
      picoliter: "",
      machineBrand: "",
      maxPrintSize: "",
      ageOfMachine: "",
    },
    checked: false,
  },
  {
    type: "Digital Printing",
    details: {
      machinePrintingSubType: "",
      picoliter: "",
      machineBrand: "",
      maxPrintSize: "",
      ageOfMachine: "",
    },
    checked: false,
  },
  {
    type: "Plotter Cutting Printing",
    details: {
      machinePrintingSubType: "",

      machineBrand: "",
      maxPrintSize: "",
      ageOfMachine: "",
    },
    checked: false,
  },
];
const machineForFabrication = [
  {
    type: "Welding Machine",
    details: {
      subCategory: "",
      ampereOfMachine: "",
      // controllerSetting: "",
      ageOfMachine: "",
    },
    checked: false,
  },
  {
    type: "Paint Compressor Machine",
    details: { subCategory: "", ageOfMachine: "" },
    checked: false,
  },
  {
    type: "CNC Router Machine",
    details: {
      subCategory: "",
      powerOfMachine: "",
      ageOfMachine: "",
      lengthFoot: "",
      breadthFoot: "",
    },
    checked: false,
  },
  {
    type: "Acrylic Laser Cutting Machine",
    details: {
      subCategory: "",
      lengthFoot: "",
      breadthFoot: "",
      ageOfMachine: "",
    },
    checked: false,
  },
  // { type: "CO2 laser", details: { Size: "", Watt: "" }, checked: false },
  {
    type: "Channel Letter Bending Machine",
    details: {
      subCategory: "",
      lengthFoot: "",
      breadthFoot: "",
      ageOfMachine: "",
      wattage: "",
      modelMachine: "",
    },
    checked: false,
  },
];

const EnquiryModal = ({
  selectedCampaign,
  adminPortalView,
  setRfpGenerate,
  getRfpList,
  rfpGenerate,
  operation,
}) => {
  const loadedDefaultsRef = useRef(new Set());
  const defaultTimerRef = useRef(null);
  const skipDefaultRef = useRef(false);
  const [allVendorsList, setAllVendorsList] = useState([]);
  const [approvedVendorsList, setApprovedVendorsList] = useState([]);
  const [vendorsFetched, setVendorsFetched] = useState(false);
  const [openCalculator, setOpenCalculator] = useState(null);

  const [locationDetails, setLocationDetails] = React.useState({
    locations: [],
  });
  let showToggles = true;
  const fileInputRef = useRef(null);
  const containerRef = useRef(null);
  const clientId = localStorage.getItem("clientId");
  const serverURL = process.env.REACT_APP_URL;
  const { id } = useParams();
  const navigate = useNavigate();
  const [organizationList, setOrganizationList] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState({});
  const [excelLoading, setExcelLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPrintMachines, setSelectedPrintMachines] = useState([]);
  const [isLocationModal, setIsLocationModal] = useState(false);
  const [locationMapModal, setLocationMapModal] = useState(false);
  const [distanceModal, setDistanceModal] = useState(false);
  const [isJobLocation, setJobLocations] = useState([]);
  const [isProduct, setProductsLocation] = useState([]);
  const [viewMapToggle, setViewMapToggle] = useState(false);
  const [vendorViewMode, setVendorViewMode] = useState("approved");
  const [formData, setFormData] = useState({
    rfpSerialNumber: selectedCampaign?.rfpSerialNumber || "",
    campaignName: selectedCampaign?.campaignName || "",
    emailAddress: selectedCampaign?.campaignOwnerId?.emailAddress || "",
    campaignOwnerName: selectedCampaign?.campaignOwnerId?.name || "",
    machanicalDetials: selectedCampaign?.machanicalDetials || "",

    startDate: selectedCampaign?.startDate
      ? dayjs(selectedCampaign.startDate)
      : null,
    endDate: selectedCampaign?.endDate ? dayjs(selectedCampaign.endDate) : null,
    teamMembers: selectedCampaign?.teamMembers
      ? selectedCampaign.teamMembers?.map((member) => ({
          emailAddress: member.emailAddress,
          id: member._id, // Store the member ID for API requests
        }))
      : [],
    phoneNumber: selectedCampaign?.campaignOwnerId?.phoneNumber || null,
    products: selectedCampaign?.products || [],
    organizationName: selectedCampaign?.organizationId?.name || "",
    document: selectedCampaign?.rfpDocument || [], // ✅ Store as an array
    addedBy: adminPortalView ? null : clientId,
    associatedBrands: selectedCampaign?.associatedBrands || [],
    turnAroundTime: selectedCampaign?.turnAroundTime || "",
    categories: selectedCampaign?.categories
      ? Array.isArray(selectedCampaign.categories)
        ? selectedCampaign.categories
        : [selectedCampaign.categories]
      : [],
    productType: selectedCampaign?.productType || [],
    addedByAdmin: adminPortalView ? localStorage.getItem("userId") : null,
    locationsUploaded: selectedCampaign?.locationsUploaded || "",
  });

  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [reportUrl, setReportUrl] = useState("");
  const [categories, setCategories] = useState([]);
  const [regions, setRegions] = useState(
    selectedCampaign?.organizationId?.zones || [],
  );
  const [productTypes, setProductTypes] = useState([]);
  const [loadingProductTypes, setLoadingProductTypes] = useState(false);

  // Fetch vendors once when map view is toggled ON
  useEffect(() => {
    const fetchAllVendorsData = async () => {
      if (viewMapToggle && !vendorsFetched) {
        try {
          const token = localStorage.getItem("token");

          // Fetch all vendors
          const allRes = await axios.get(
            `${process.env.REACT_APP_URL}/api/vendorsForMap`,
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          );
          if (allRes?.data?.success) {
            setAllVendorsList(allRes.data.data || []);
          }

          // Fetch approved vendors
          const approvedRes = await axios.get(
            `${process.env.REACT_APP_URL}/api/vendorsForMap?approvedOnly=true`,
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          );
          if (approvedRes?.data?.success) {
            setApprovedVendorsList(approvedRes.data.data || []);
          }

          setVendorsFetched(true);
        } catch (error) {
          console.error("Error fetching vendors:", error);
        }
      }
    };

    fetchAllVendorsData();
  }, [viewMapToggle, vendorsFetched]);

  // Add this useEffect to fetch vendors once when modal opens:
  useEffect(() => {
    const fetchAllVendorsData = async () => {
      if (openCalculator !== null && !vendorsFetched) {
        try {
          const token = localStorage.getItem("token");

          // Fetch all vendors
          const allRes = await axios.get(
            `${process.env.REACT_APP_URL}/api/vendorsForMap`,
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          );
          if (allRes?.data?.success) {
            setAllVendorsList(allRes.data.data || []);
          }

          // Fetch approved vendors
          const approvedRes = await axios.get(
            `${process.env.REACT_APP_URL}/api/vendorsForMap?approvedOnly=true`,
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          );
          if (approvedRes?.data?.success) {
            setApprovedVendorsList(approvedRes.data.data || []);
          }

          setVendorsFetched(true);
        } catch (error) {
          console.error("Error fetching vendors:", error);
        }
      }
    };

    fetchAllVendorsData();
  }, [openCalculator, vendorsFetched]);

  useEffect(() => {
    if (operation === "view") return;
    fetch(`${serverURL}/itemMaster/categories`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setCategories(data.data || []);
      })
      .catch((err) => {
        console.error("Category API error:", err);
      });
  }, []);

  useEffect(() => {
    if (
      operation !== "edit" &&
      operation !== "view" &&
      operation !== "duplicate"
    )
      return;

    if (operation === "view") return;
    if (!formData.categories?.length) return;

    setLoadingProductTypes(true);

    fetch(
      `${serverURL}/itemMaster/product-types?categories=${encodeURIComponent(
        formData.categories.join(","),
      )}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    )
      .then((res) => res.json())
      .then((json) => {
        setProductTypes(json.data || []);
      })
      .catch(() => setProductTypes([]))
      .finally(() => setLoadingProductTypes(false));
  }, [operation]); // 👈 ONLY once on edit/view

  const handleCategoryChange = async (newCategories) => {
    setFormData((prev) => {
      const oldProductTypes = prev.productType || [];
      const oldProducts = prev.products || [];

      return {
        ...prev,
        categories: newCategories,

        // ❌ DO NOT auto add productType
        productType: oldProductTypes,
        products: oldProducts,
      };
    });

    // if no category → clear everything
    if (!newCategories.length) {
      setProductTypes([]);
      setFormData((prev) => ({
        ...prev,
        productType: [],
        products: [],
      }));
      setActiveProduct("");
      return;
    }

    setLoadingProductTypes(true);

    try {
      const res = await fetch(
        `${serverURL}/itemMaster/product-types?categories=${encodeURIComponent(
          newCategories.join(","),
        )}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const json = await res.json();
      const allowedProductTypes = json.data || [];

      // 🔥 REMOVE invalid selected productTypes
      setFormData((prev) => {
        const filteredProductTypes = (prev.productType || []).filter((pt) =>
          allowedProductTypes.includes(pt),
        );

        const filteredProducts = (prev.products || []).filter((p) =>
          allowedProductTypes.includes(p.productType),
        );

        return {
          ...prev,
          productType: filteredProductTypes,
          products: filteredProducts,
        };
      });

      // dropdown options only
      setProductTypes(allowedProductTypes);
    } catch (err) {
      console.error("ProductTypes API error:", err);
      setProductTypes([]);
    } finally {
      setLoadingProductTypes(false);
    }
  };

  useEffect(() => {
    if (skipDefaultRef.current) {
      skipDefaultRef.current = false;
      return;
    }
    if (!formData.productType?.length) return;

    if (operation === "view") return;

    if (defaultTimerRef.current) {
      clearTimeout(defaultTimerRef.current);
    }

    defaultTimerRef.current = setTimeout(async () => {
      try {
        const res = await fetch(
          `${serverURL}/itemMaster/product-types/defaults`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify({ productTypes: formData.productType }),
          },
        );

        const json = await res.json();
        if (!json.success) return;

        setFormData((prev) => {
          const productsMap = new Map(
            (prev.products || []).map((p) => [p.productType, p]),
          );

          const mergedProducts = prev.productType.map((type) => {
            const existing = productsMap.get(type);

            const defaults = json.data[type];

            return {
              productType: type,
              fabricationDetails:
                existing?.fabricationDetails ||
                defaults?.fabricationDetails ||
                "",
              electricalDetails:
                existing?.electricalDetails ||
                defaults?.electricalDetails ||
                "",
              printingDetails:
                existing?.printingDetails || defaults?.printingDetails || "",
              description: existing?.description || defaults?.description || "",

              // keep old data
              servicesNeeded: existing?.servicesNeeded || [
                "Recce",
                "Printing",
                "Fabrication",
                "Installation",
              ],
              machinesNeededForPrinting:
                existing?.machinesNeededForPrinting || [],
              machinesNeededForFabrication:
                existing?.machinesNeededForFabrication || [],
              machineNeededForPainting:
                existing?.machineNeededForPainting || false,
              costCalculator: existing?.costCalculator || null,
            };
          });

          return {
            ...prev,
            products: mergedProducts,
          };
        });
      } catch (err) {
        console.error("Bulk defaults error:", err);
      }
    }, 300);

    return () => {
      if (defaultTimerRef.current) {
        clearTimeout(defaultTimerRef.current);
      }
    };
  }, [formData.productType, operation]);
  useEffect(() => {
    if (selectedOrganization?.organizationDetail?.zones) {
      let listOfRegions = selectedOrganization?.organizationDetail?.zones.map(
        (zone) => ({ regionName: zone.regionName }),
      );
      setRegions(listOfRegions);
    }
  }, [selectedOrganization?.organizationDetail?.zones]);
  const handleOpenReport = (url) => {
    setReportUrl(url);
    setIsReportModalOpen(true);
  };
  const handelReportModal = () => {
    setIsReportModalOpen(false);
  };

  const handlePrintMachineSelection = (productType, machineType, type) => {
    setFormData((prev) => ({
      ...prev,
      products: prev.products?.map((product) => {
        if (product.productType !== productType) return product;

        const machineExists = product?.[type]?.find(
          (m) => m.type === machineType,
        );

        let updatedMachines;
        if (machineExists) {
          if (machineExists.checked) {
            // Remove it if currently checked
            updatedMachines = product?.[type]?.filter(
              (m) => m.type !== machineType,
            );
          } else {
            // Mark it checked
            updatedMachines = product?.[type]?.map((m) =>
              m.type === machineType ? { ...m, checked: true } : m,
            );
          }
        } else {
          // Add machine if not already present (default checked: true)
          let machineFromMaster;
          if (type === "machinesNeededForFabrication") {
            machineFromMaster = machineForFabrication.find(
              (m) => m.type === machineType,
            );
          } else if (type === "machinesNeededForPrinting") {
            machineFromMaster = machineForPrinting.find(
              (m) => m.type === machineType,
            );
          }
          updatedMachines = [
            ...(product?.[type] || []),
            { ...machineFromMaster, checked: true },
          ];
        }

        return {
          ...product,
          [type]: updatedMachines,
        };
      }),
    }));
  };
  const handleDeleteMachineSelection = (
    machineCategory, // e.g. "machinesNeededForPrinting" or "machineNeededForFabrication"
    productType,
    machineType,
  ) => {
    setFormData((prev) => ({
      ...prev,
      products: prev.products?.map((product) => {
        if (product.productType !== productType) return product;

        return {
          ...product,
          [machineCategory]: product[machineCategory].filter(
            (machine) => machine.type !== machineType,
          ),
        };
      }),
    }));
  };

  const handleInputChangeMachineDetails = (
    productType,
    machineCategory,
    machineType,
    field,
    value,
    extra = {},
  ) => {
    setFormData((prev) => ({
      ...prev,
      products: prev.products?.map((product) => {
        if (product.productType !== productType) return product;

        return {
          ...product,
          [machineCategory]: product[machineCategory]?.map((m) => {
            if (m.type !== machineType) return m;

            // ✅ If field is "lengthFoot", auto-calculate breadthFoot
            let newDetails = {
              ...(m.details || {}),
              [field]: value,
              ...extra,
            };

            if (field === "lengthFoot") {
              const mapping = getMapping(machineType); // mapping based on machine
              const autoBreadth = mapping?.[value]; // lookup breadth from mapping
              if (autoBreadth) {
                newDetails.breadthFoot = autoBreadth; // set breadth automatically
              }
            }

            return {
              ...m,
              details: newDetails,
            };
          }),
        };
      }),
    }));
  };

  const [team, setTeam] = useState([]);
  const [teamMember, setTeamMember] = useState("");
  const [userDomain, setUserDomain] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [teamError, setteamError] = useState(false);
  const [errors, setErrors] = useState({});
  const [documentUrl, setdocumentUrl] = useState("");
  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const [modalOnView, setModalOnView] = useState("rfp");
  const [open, setOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [activeProduct, setActiveProduct] = useState("");
  const [isPrintOpen, setPrintIsOpen] = useState(false);
  const [isFabOpen, setFabIsOpen] = useState(false);

  const [productErrors, setProductErrors] = useState([]);
  const [productType, setProductType] = useState([]);
  const [isReportsModal, setReportsModal] = useState(false);
  const [enquiryId, setEnquiryId] = useState(null);
  const [isRfpSerial, setRfpSerial] = useState(null);
  const [totalArea, setTotalArea] = useState(0);
  const [approvedVendorsListForAccordion, setApprovedVendorsListForAccordion] =
    useState([]);

  const [locationsWithCoords, setLocationsWithCoords] = useState([]);
  const [isFetchingCoordinates, setIsFetchingCoordinates] = useState(false);

  // fetch the location coordinates to pass to cost calculator and city accordion
  useEffect(() => {
    const fetchCoordinates = async () => {
      if (!locationDetails?.locations?.length) {
        setLocationsWithCoords([]);
        return;
      }

      setIsFetchingCoordinates(true);

      try {
        const enriched = await Promise.all(
          locationDetails.locations.map(async (loc) => {
            if (loc.locationCoordinates?.lat && loc.locationCoordinates?.lng) {
              return loc; // already has coords
            }

            const { address, city, state, zipCode } = loc.details || {};

            const coords = await getAddressLatLong(
              address,
              city,
              state,
              zipCode,
            );

            return {
              ...loc,
              locationCoordinates: coords || null,
            };
          }),
        );

        setLocationsWithCoords({
          locations: enriched,
        });
      } catch (error) {
        console.error("Error fetching coordinates:", error);
        setLocationsWithCoords([]);
      } finally {
        setIsFetchingCoordinates(false);
      }
    };

    if (openCalculator !== null) {
      fetchCoordinates();
    }
  }, [locationDetails, openCalculator]);

  const rfpFileInputRef = useRef(null);
  const locationFileInputRef = useRef(null);

  const handleOpenModal = (doc) => {
    setSelectedDoc(doc);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setSelectedDoc(null);
  };
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const fetchOrganizationList = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const query = new URLSearchParams({
        addedBy: userId, // Add userId to filter by the user who added the organization
      });
      const response = await axios.get(
        `${serverURL}/organization/view?${query.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        setOrganizationList(response.data.data);
        if (
          operation === "view" ||
          operation === "edit" ||
          operation === "duplicate"
        ) {
          let selectedOrg = response?.data?.data.filter(
            (org) => org.organizationName === formData.organizationName,
          );
          setSelectedOrganization(selectedOrg);
        }
      }
    } catch (error) {
      console.error("Error in fetching organization list", error);
    }
  };

  useEffect(() => {
    if (operation === "view") return;
    fetchOrganizationList();
  }, []);

  //get all client id--------------------------------/client/dashboard
  const fetchAllTeamMembers = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/client/dashboard?organizationName=${encodeURIComponent(formData.organizationName)}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      setTeam(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (operation === "view") return;

    fetchAllTeamMembers();
  }, [operation, formData.organizationName]);

  React.useEffect(() => {
    const fetchLocationDetails = async () => {
      if (formData.locationsUploaded) {
        const { locations, totalArea } = await ExtractDataFromExcel(
          formData.locationsUploaded,
        );

        setLocationDetails({ locations });

        const LocationArray = locations.map((s, i) => s.details);
        const ProductArray = locations.map((s, i) => s.product);
        setJobLocations(LocationArray);
        setProductsLocation(ProductArray);

        setFormData((prev) => ({
          ...prev,
          totalArea: totalArea,
        }));
      }
    };

    fetchLocationDetails();
  }, [formData.locationsUploaded]);

  useEffect(() => {
    let objectUrl;
    if (formData.document instanceof File) {
      objectUrl = URL.createObjectURL(formData.document);
      setdocumentUrl(objectUrl);
    } else {
      setdocumentUrl(formData.document);
    }

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [formData.document]);

  let productError;
  const validateForm = () => {
    const newErrors = {};

    if (!formData.campaignName)
      newErrors.campaignName = "Campaign name is required";

    // if (formData.document.length === 0) {
    //   newErrors.document = "Document is required";
    // }
    if (formData.productType?.length === 0) {
      newErrors.productType = "Select at least one product";
    }

    if (!formData.organizationName) {
      newErrors.organizationName = "Client Name is required";
    }
    // if (!formData.emailAddress) {
    //   newErrors.emailAddress = "Email is Required";
    // } else {
    //   const emailDomain = formData.emailAddress.split("@")[1];
    if (!formData.emailAddress) {
      newErrors.emailAddress = "Campaign owner email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(formData.emailAddress)) {
        newErrors.emailAddress = "Please enter a valid email address";
      } else {
        const emailDomain = formData.emailAddress.split("@")[1];

        if (!adminPortalView && emailDomain !== userDomain) {
          newErrors.emailAddress = `Email domain must match the domain ${userDomain}`;
        }
      }
    }

    if (
      !formData.phoneNumber ||
      formData.phoneNumber.toString()?.length !== 10
    ) {
      newErrors.phoneNumber = "Please enter a valid 10-digit contact number";
    }
    if (!formData.campaignOwnerName)
      newErrors.campaignOwnerName = "Campaign owner name is required";
    if (!formData.turnAroundTime) {
      newErrors.turnAroundTime = "Project Turn Around Time is required";
    }
    if (!formData.associatedBrands) {
      newErrors.associatedBrands = "Associated Brand is required";
    }

    productError = formData?.products
      .map((ele) => {
        let allProductError = {};
        // if (!ele?.description) {
        //   allProductError.description = "Please Fill Description";
        //   allProductError.productType = ele?.productType;
        // }

        if (!ele?.servicesNeeded || ele?.servicesNeeded?.length === 0) {
          allProductError.servicesNeeded = "Please Select at least one Service";
          allProductError.productType = ele?.productType;
        }

        // return only if object has at least one error
        return Object?.keys(allProductError)?.length > 0 && allProductError;
      })
      .filter(Boolean);
    if (productError.length > 0) {
      newErrors.productsErrors = productError;
    }

    setProductErrors(productError);

    if (!formData.productType) {
      newErrors.productType = "Product Type is required";
    }

    // if (!formData.document) newErrors.document = "Upload RFP document";

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, organizationId = "" } = e.target;
    setFormData((prevFormData) => {
      const updatedData = { ...prevFormData, [name]: value };

      // Automatically calculate campaignValue when sellingPrice or totalArea changes
      if (name === "sellingPrice" || name === "totalArea") {
        const sellingPrice = parseFloat(updatedData.sellingPrice) || 0;
        const totalArea = parseFloat(updatedData.totalArea) || 0;
        updatedData.campaignValue = (sellingPrice * totalArea).toFixed(2);
      }

      if (name === "organizationName") {
        // Immediately clear team and related fields
        setTeam([]);
        let org = organizationList.find(
          (org) => org.organizationDetail._id === organizationId,
        );
        setSelectedOrganization(org);
        updatedData.emailAddress = "";
        updatedData.teamMembers = [];
        updatedData.campaignOwnerName = "";
        updatedData.phoneNumber = "";
        // Fetch new team members asynchronously
        // fetchAllTeamMembers();
      }

      if (name === "document") {
        if (updatedData.document?.length > 4) {
          setErrors((prev) => ({
            ...prev,
            document: "Please Upload Maximum Four Documents",
          }));
        }
      }
      if (name === "turnAroundTime") {
        setErrors((prev) => ({
          ...prev,
          turnAroundTime: false,
        }));
      }

      if (name === "startDate") {
        setErrors((prev) => ({
          ...prev,
          startDate: !value,
        }));

        if (
          updatedData.endDate &&
          updatedData.endDate < updatedData.startDate
        ) {
          setErrors((prev) => ({
            ...prev,
            endDate: "Enter valid end Date",
          }));
        } else {
          setErrors((prev) => ({ ...prev, endDate: false }));
        }
      }

      if (name === "endDate") {
        setErrors((prev) => ({
          ...prev,
          endDate:
            !value ||
            (prevFormData.startDate && value < prevFormData.startDate),
        }));

        if (prevFormData.startDate && value < prevFormData.startDate) {
          setErrors((prev) => ({ ...prev, endDate: "Enter a valid End Date" }));
        }
      }

      if (name === "campaignName") {
        setErrors((prev) => ({
          ...prev,
          campaignName: !value,
        }));
      }

      if (name === "emailAddress") {
        updatedData.campaignOwnerName =
          team.find((member) => member.emailAddress === value)?.name || "";
        updatedData.phoneNumber =
          team.find((member) => member.emailAddress === value)?.phoneNumber ||
          "";
      }

      // ✅ Handle productType multi-select
      if (name === "productType") {
        const selectedValues = Array.isArray(value) ? value : [value];
        updatedData.productType = selectedValues;
        updatedData.products = selectedValues.map((type) => {
          const existing = prevFormData.products?.find(
            (p) => p.productType === type,
          );

          return existing || initializeProduct(type);
        });
        return updatedData;
      }

      return updatedData;
    });
  };

  const handleProductInputChange = (productType, e) => {
    const { value, name } = e.target;

    setFormData((prev) => ({
      ...prev,
      products: prev.products?.map((ele) =>
        ele?.productType === productType ? { ...ele, [name]: value } : ele,
      ),
    }));

    // ✅ remove error if field is description
    if (name === "description") {
      setProductErrors((prevErrors) =>
        prevErrors.map((err) => {
          if (err?.productType === activeProduct && err?.description) {
            return {
              ...err,
              description: false,
            };
          }
          return err;
        }),
      );
    }
  };

  const MachineModalOpen = () => {
    setPrintIsOpen(true);
  };
  const handleCloseMachineBox = () => {
    setPrintIsOpen(false);
  };
  const handleFabMachineModalOpen = () => {
    setFabIsOpen(true);
  };
  const handleCloseFabModal = () => {
    setFabIsOpen(false);
  };

  const handlePaintingMachine = () => {
    setFormData((prev) => ({
      ...prev,
      products: prev.products.map((ele) => {
        if (ele.productType === activeProduct) {
          return {
            ...ele,
            machineNeededForPainting: !ele.machineNeededForPainting, // toggle boolean
          };
        }
        return ele;
      }),
    }));
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleService = (productType, challenge) => {
    setFormData((prevFormData) => {
      const updatedProducts = prevFormData.products?.map((product) => {
        if (product.productType === productType) {
          const currentServices = product.servicesNeeded || []; // ✅ fallback

          const updatedSelectedChallenges = currentServices.includes(challenge)
            ? currentServices.filter((item) => item !== challenge)
            : [...currentServices, challenge];

          return {
            ...product,
            servicesNeeded: updatedSelectedChallenges,
          };
        }
        return product;
      });

      // ✅ update errors per product (if you want per-product validation)
      setErrors((prevErrors) => ({
        ...prevErrors,
        servicesNeeded: updatedProducts.find(
          (p) => p.productType === productType,
        )?.servicesNeeded?.length
          ? false
          : "Please select at least one service",
      }));

      return {
        ...prevFormData,
        products: updatedProducts,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!validateForm()) {
      const allErrorsName = productError.map((ele) => {
        if (ele.productType) {
          return ele.productType;
        }
      });

      Swal.fire({
        customClass: { container: "my-swal" },
        icon: "error",
        text: `Please fill out the required fields correctly ${
          allErrorsName.length > 0
            ? "Error in these products: " + allErrorsName.join(", ")
            : ""
        }`,
        color: "black",
      });

      setIsLoading(false); // ✅ Stop loading if validation fails
      return;
    }

    try {
      if (operation === "edit") {
        try {
          //fetch all the report delete and then update new Reports to the products

          const AllReports = formData?.products?.flatMap((ele) =>
            [
              ele.fabricationReport && ele.fabricationReport,
              ele.printingReport && ele.printingReport,
              ele.paintingReport && ele.paintingReport,
            ].filter(Boolean),
          );
          if (AllReports?.length > 0) {
            const deleteResponse = await axios.post(
              `${serverURL}/deleteUpload`,
              { keys: AllReports },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              },
            );
          }

          const updatedData = {
            ...formData,
            teamMembers: formData.teamMembers?.map((member) => member.id),
            reportsStatus: "update",
          };
          setFormData(updatedData);

          const response = await axios.put(
            `${serverURL}/requestForProposal/editRfp/${selectedCampaign?._id}?updateEmailSend=true`,
            updatedData,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            },
          );
          if (response.status === 200) {
            setIsLoading(false); // ✅ Stop loading BEFORE Swal
            setEnquiryId(response.data.data._id);
            setRfpSerial(response.data.rfpSerialNumber);

            // setReportsModal(true);

            Swal.fire({
              customClass: { container: "my-swal" },
              icon: "success",
              text: "Enquiry Updated Successfully",
              padding: "1em",
              color: "black",
            }).then(() => {
              setRfpGenerate(false);
              getRfpList();
              navigate("/adminportal/enquiry");
            });
          }
        } catch (error) {
          console.error("Error updating Enquiry:", error);
          setIsLoading(false);
          Swal.fire({
            customClass: { container: "my-swal" },
            icon: "error",
            title: error.response?.data?.message || "Update failed",
            padding: "1em",
          });
        }
      } else {
        try {
          const response = await axios.post(
            `${serverURL}/requestForProposal/addRfp`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            },
          );

          if (response.data.success === true) {
            setEnquiryId(response.data.data._id);
            setRfpSerial(response.data.rfpSerialNumber);
            Swal.fire({
              customClass: { container: "my-swal" },
              icon: "success",
              text: "Enquiry Created Successfully",

              padding: "1em",
              color: "black",
            }).then(() => {
              if (adminPortalView) {
                setRfpGenerate(false);
                getRfpList();
                navigate("/adminportal/enquiry");
              } else {
                navigate("/user/enquiry");
              }
            });

            setIsLoading(false); // ✅ Stop loading before Swal.fire
          } else {
            setIsLoading(false);
            Swal.fire({
              customClass: { container: "my-swal" },
              icon: "error",
              text: response.data.message || "Client not found",
            });
          }
        } catch (error) {
          console.error("Error creating Enquiry:", error);
          setIsLoading(false);
          Swal.fire({
            customClass: { container: "my-swal" },
            icon: "error",
            title: error.response?.data?.notFound
              ? "Add Organization"
              : "Create failed",
            text: error.response?.data?.message,

            padding: "1em",
            color: "var(--heading-color)",
          });
        }
      }
    } catch (error) {
      console.error("Error processing Enquiry:", error);
      setIsLoading(false);
      Swal.fire({
        customClass: { container: "my-swal" },
        icon: "error",
        title: error.response?.data?.message || "Operation failed",
        text: "Error in processing the organization details",
        color: "black",
      });
    }
  };
  const handleRemoveDocument = (index) => {
    setFormData((prev) => ({
      ...prev,
      document: prev.document.filter((_, i) => i !== index),
    }));
  };

  const handleClose = () => {
    setRfpGenerate(false);
  };

  const handleTotalAreaChange = (newTotal) => {
    setTotalArea(newTotal);
  };
  const handleIconClick = () => {
    // Trigger the file input click when the icon is clicked
    locationFileInputRef.current.click();
  };

  const onAddNew = () => {
    // setIsModalOpen(true); // Open the modal when the button is clicked
    navigate("/adminportal/clientDetails/add/details");
  };

  // Function to close the modal
  const handleClientCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const handleGoBack = () => {
    if (activeProduct != "") {
      setActiveProduct("");
    } else {
      setRfpGenerate(false);
    }
  };
  const initializeProduct = (productType) => ({
    productType,
    fabricationDetails: "",
    electricalDetails: "",
    printingDetails: "",
    description: "",
    servicesNeeded: [],
    machinesNeededForPrinting: [],
    machinesNeededForFabrication: [],
    machineNeededForPainting: false,
    costCalculator: null,
  });

  return (
    <Dialog
      open={rfpGenerate}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          setRfpGenerate(false);
        }
      }}
      fullWidth
      maxWidth="xl"
    >
      <DialogContent className="!p-0">
        <div
          className={`min-h-[600px] mb-8 flex  justify-center bg-[#f9f9f9]  ml-0 md:mb-3 relative ${
            adminPortalView ? "min-h-[500px]" : ""
          }`}
        >
          <Grid>
            <div className="px-2  sm:min-w-2xl md:max-w-[42rem] lg:max-w-[60rem] xl:min-w-[72rem] 2xl:min-w-[90rem]">
              <div className="  ml-6 mt-8">
                <button onClick={handleGoBack}>
                  <ArrowBackIcon className="mr-2" />
                  {activeProduct === "" ? "Go Back" : "Go to Enquiry"}
                </button>
                <h2 className="mt-4 font-bold text-2xl"> Create Enquiry</h2>
              </div>

              <div>
                {formData.productType?.length > 0 && (
                  <ProductTabs
                    products={formData.productType}
                    activeProduct={activeProduct}
                    setActiveProduct={setActiveProduct}
                    CostCalculator={formData.products}
                  />
                )}

                {activeProduct === "" ? (
                  <>
                    <EnquiryHeader
                      formData={formData}
                      regions={regions}
                      selectedOrganization={selectedOrganization}
                      handleRemoveDocument={handleRemoveDocument}
                      setFormData={setFormData}
                      setExcelLoading={setExcelLoading}
                      setProductsLocation={setProductsLocation}
                      isProduct={isProduct}
                      setSnackbar={setSnackbar}
                      setJobLocations={setJobLocations}
                      operation={operation}
                      errors={errors}
                      handleInputChange={handleInputChange}
                      handleOpenModal={handleOpenModal}
                      saveButtonClicked={saveButtonClicked}
                      validateForm={validateForm}
                      selectedCampaign={selectedCampaign}
                      onAddNew={onAddNew}
                      organizationList={organizationList}
                      team={team}
                      PRODUCT_TYPES={PRODUCT_TYPES}
                      categories={categories}
                      productTypes={productTypes}
                      loadingProductTypes={loadingProductTypes}
                      onCategoryChange={handleCategoryChange}
                      // onProductTypeChange={handleProductTypeChange}
                      setIsLocationModal={setIsLocationModal}
                      isLocationModal={isLocationModal}
                      setLocationMapModal={setLocationMapModal}
                      distanceModal={distanceModal}
                      setDistanceModal={setDistanceModal}
                      locationMapModal={locationMapModal}
                      locationFileInputRef={locationFileInputRef}
                      handleFileUploadForLocations={
                        handleFileUploadForLocations
                      }
                      isJobLocation={isJobLocation}
                      excelLoading={excelLoading}
                      handleIconClick={handleIconClick}
                    />
                  </>
                ) : (
                  <div>
                    {formData?.productType.length > 0 &&
                      formData?.products?.map((ele, index) => {
                        return (
                          <div key={index}>
                            {ele.productType == activeProduct && (
                              <>
                                <div key={index}>
                                  <div className=" bg-white mx-6 mb-6 p-10 rounded-b-lg  shadow ">
                                    <div className="flex justify-between">
                                      <h3 className="text-gray-400 font-bold mb-4">
                                        PRODUCT SPECIFICATION
                                      </h3>
                                      {localStorage.getItem("role") != "1" && (
                                        <button
                                          onClick={() =>
                                            setOpenCalculator(index)
                                          }
                                          className={`py-2 px-10 rounded mx-4 font-bold border border-blue-300 bg-white text-[var(--primary-color)] shadow-md shadow-blue-300 `}
                                        >
                                          View Map
                                        </button>
                                      )}
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 ">
                                      <Grid item xs={12} md={12} lg={12}>
                                        <div className=" flex justify-between relative items-center">
                                          <label
                                            className="text-[12px] font-[500]"
                                            style={{
                                              marginBottom: "6px",
                                              marginTop: "16px",
                                              display: "block",
                                            }}
                                          >
                                            Fabrication Details
                                          </label>

                                          {/* Character Counter */}
                                          <span
                                            style={{
                                              fontSize: "11px",
                                              color: "#888",
                                            }}
                                          >
                                            {ele?.fabricationDetails?.length ||
                                              0}
                                            /200
                                          </span>
                                        </div>

                                        <TextField
                                          className="text-xs font-medium leading-6 text-left w-full"
                                          placeholder="Enter Your Fabrication Details"
                                          title="Fabrication Details"
                                          multiline
                                          type="text"
                                          value={ele?.fabricationDetails || ""}
                                          rows={3}
                                          inputProps={{ maxLength: 200 }} // limit to 200 chars
                                          size="small"
                                          name="fabricationDetails"
                                          sx={{
                                            "& .MuiOutlinedInput-root": {
                                              "& fieldset": {
                                                borderColor:
                                                  "var(--listdown-color)",
                                              },
                                              "&:hover fieldset": {
                                                borderColor:
                                                  "var(--listdown-color)",
                                              },
                                              "&.Mui-focused fieldset": {
                                                borderColor:
                                                  "var(--primary-color)",
                                              },
                                            },
                                          }}
                                          onChange={(e) =>
                                            handleProductInputChange(
                                              ele.productType,
                                              e,
                                            )
                                          }
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              e.preventDefault(); // 🚫 prevents new line
                                            }
                                          }}
                                          disabled={operation === "view"}
                                        />
                                      </Grid>

                                      <Grid item xs={12} md={12} lg={12}>
                                        <div className=" flex justify-between relative items-center">
                                          <label
                                            className="text-[12px] font-[500]"
                                            style={{
                                              marginBottom: "6px",
                                              marginTop: "16px",
                                              display: "block",
                                            }}
                                          >
                                            Electrical Details
                                          </label>

                                          {/* Character Counter */}
                                          <span
                                            style={{
                                              fontSize: "11px",
                                              color: "#888",
                                            }}
                                          >
                                            {ele?.electricalDetails?.length ||
                                              0}
                                            /200
                                          </span>
                                        </div>

                                        <TextField
                                          className="text-xs font-medium leading-6 text-left w-full"
                                          placeholder="Enter Your Electrical Details"
                                          title="Electrical Details"
                                          multiline
                                          rows={3}
                                          type="text"
                                          value={ele?.electricalDetails || ""}
                                          inputProps={{ maxLength: 200 }} // limit to 200 chars
                                          size="small"
                                          name="electricalDetails"
                                          sx={{
                                            "& .MuiOutlinedInput-root": {
                                              "& fieldset": {
                                                borderColor:
                                                  "var(--listdown-color)",
                                              },
                                              "&:hover fieldset": {
                                                borderColor:
                                                  "var(--listdown-color)",
                                              },
                                              "&.Mui-focused fieldset": {
                                                borderColor:
                                                  "var(--primary-color)",
                                              },
                                            },
                                          }}
                                          onChange={(e) =>
                                            handleProductInputChange(
                                              ele.productType,
                                              e,
                                            )
                                          }
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              e.preventDefault(); // 🚫 prevents new line
                                            }
                                          }}
                                          disabled={operation === "view"}
                                        />
                                      </Grid>

                                      <Grid item xs={12} md={12} lg={12}>
                                        <div className=" flex justify-between relative items-center">
                                          <label
                                            className="text-[12px] font-[500]"
                                            style={{
                                              marginBottom: "6px",
                                              marginTop: "16px",
                                              display: "block",
                                            }}
                                          >
                                            Printing Details
                                          </label>

                                          {/* Character Counter */}
                                          <span
                                            style={{
                                              fontSize: "11px",
                                              color: "#888",
                                            }}
                                          >
                                            {ele?.printingDetails?.length || 0}
                                            /200
                                          </span>
                                        </div>

                                        <TextField
                                          className="text-xs font-medium leading-6 text-left w-full"
                                          placeholder="Enter Your Printing Details"
                                          title="Printing Details"
                                          multiline
                                          rows={3}
                                          type="text"
                                          value={ele?.printingDetails || ""}
                                          inputProps={{ maxLength: 200 }} // limit to 200 chars
                                          size="small"
                                          name="printingDetails"
                                          sx={{
                                            "& .MuiOutlinedInput-root": {
                                              "& fieldset": {
                                                borderColor:
                                                  "var(--listdown-color)",
                                              },
                                              "&:hover fieldset": {
                                                borderColor:
                                                  "var(--listdown-color)",
                                              },
                                              "&.Mui-focused fieldset": {
                                                borderColor:
                                                  "var(--primary-color)",
                                              },
                                            },
                                          }}
                                          onChange={(e) =>
                                            handleProductInputChange(
                                              ele.productType,
                                              e,
                                            )
                                          }
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              e.preventDefault(); // 🚫 prevents new line
                                            }
                                          }}
                                          disabled={operation === "view"}
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={12} lg={12}>
                                        <div className=" flex justify-between relative items-center">
                                          <label
                                            className={`text-[12px] font-[500] ${
                                              productErrors.find(
                                                (err) =>
                                                  err?.productType ===
                                                    activeProduct &&
                                                  err?.description,
                                              )
                                                ? "text-red-500"
                                                : ""
                                            }`}
                                            style={{
                                              marginBottom: "6px",
                                              display: "block",
                                              marginTop: "16px",
                                            }}
                                          >
                                            Description
                                          </label>

                                          {/* Character Counter */}
                                          <span
                                            style={{
                                              fontSize: "11px",
                                              color: "#888",
                                            }}
                                          >
                                            {ele?.description?.length || 0}
                                            /200
                                          </span>
                                        </div>

                                        <TextField
                                          className="text-xs font-medium leading-6 text-left w-full"
                                          placeholder="Enter Your Description"
                                          title="Description"
                                          multiline
                                          // minRows={1}
                                          // maxRows={4}
                                          rows={3}
                                          type="text"
                                          value={ele?.description || ""}
                                          inputProps={{ maxLength: 200 }} // limit to 200 chars
                                          size="small"
                                          name="description"
                                          sx={{
                                            "& .MuiOutlinedInput-root": {
                                              "& fieldset": {
                                                borderColor: productErrors.find(
                                                  (err) =>
                                                    err?.productType ===
                                                      activeProduct &&
                                                    err?.description,
                                                )
                                                  ? "#ef4444"
                                                  : "var(--listdown-color)",
                                              },
                                              "&:hover fieldset": {
                                                borderColor: productErrors.find(
                                                  (err) =>
                                                    err?.productType ===
                                                      activeProduct &&
                                                    err?.description,
                                                )
                                                  ? "#ef4444"
                                                  : "var(--listdown-color)",
                                              },
                                              "&.Mui-focused fieldset": {
                                                borderColor: productErrors.find(
                                                  (err) =>
                                                    err?.productType ===
                                                      activeProduct &&
                                                    err?.description,
                                                )
                                                  ? "#ef4444"
                                                  : "var(--primary-color)",
                                              },
                                            },
                                          }}
                                          onChange={(e) =>
                                            handleProductInputChange(
                                              ele.productType,
                                              e,
                                            )
                                          }
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              e.preventDefault(); // 🚫 prevents new line
                                            }
                                          }}
                                          disabled={operation === "view"}
                                        />
                                        {productErrors.find(
                                          (err) =>
                                            err?.productType ===
                                              activeProduct && err?.description,
                                        ) && (
                                          <FormHelperText
                                            className="text-[var(--error-color)] text-[12px] -mt-3 ml-3"
                                            sx={{
                                              color: "var(--error-color)",
                                              marginTop: 1,
                                              marginLeft: 1.5,
                                            }}
                                          >
                                            {
                                              productErrors.find(
                                                (err) =>
                                                  err?.productType ===
                                                    activeProduct &&
                                                  err?.description,
                                              )?.description
                                            }
                                          </FormHelperText>
                                        )}
                                      </Grid>
                                    </div>
                                  </div>

                                  <Dialog
                                    open={openCalculator === index}
                                    onClose={() => setOpenCalculator(null)}
                                    fullWidth
                                    maxWidth="lg" // large modal
                                  >
                                    <DialogTitle>
                                      Map
                                      <IconButton
                                        aria-label="close"
                                        onClick={() => {
                                          setViewMapToggle(false);
                                          setOpenCalculator(null);
                                        }}
                                        sx={{
                                          position: "absolute",
                                          right: 8,
                                          top: 8,
                                        }}
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </DialogTitle>

                                    <DialogContent dividers>
                                      {/* <CostCalculator
                                        handleTotalAreaChange={
                                          handleTotalAreaChange
                                        }
                                        locationDetails={locationDetails}
                                        setLocationDetails={setLocationDetails}
                                        totalArea={totalArea.toFixed(2)}
                                        viewMapToggle={viewMapToggle}
                                        setViewMapToggle={setViewMapToggle}
                                        operation={operation}
                                        setSnackbar={setSnackbar}
                                        snackbar={snackbar}
                                        setOpenCalculator={setOpenCalculator}
                                        activeProduct={ele.productType}
                                        existingQuotation={ele.costCalculator}
                                        productIndex={index}
                                        onSubmitChanges={(
                                          updatedData,
                                          productIndex,
                                        ) => {
                                          setFormData((prev) => {
                                            const newProducts = [
                                              ...prev.products,
                                            ];
                                            newProducts[
                                              productIndex
                                            ].costCalculator = updatedData;
                                            return {
                                              ...prev,
                                              products: newProducts,
                                            };
                                          });
                                        }}
                                      /> */}

                                      {/* <div>
                                        <ProductStoreMapping
                                          CampaignDetails={locationsWithCoords}
                                          showToggles={showToggles}
                                          activeProduct={activeProduct}
                                          setProductType={setProductType}
                                          productType={productType}
                                        />

                                        <div className="col-span-12 mt-4 bg-white p-6 rounded-lg shadow">
                                          <CityAccordion
                                            data={locationsWithCoords}
                                            productType={activeProduct}
                                            showDropdown={true}
                                            showVendors={true}
                                            onTotalAreaChange={
                                              handleTotalAreaChange
                                            }
                                            formData={formData}
                                          />
                                        </div>
                                      </div> */}
                                      {isFetchingCoordinates ? (
                                        <div className="flex justify-center items-center h-[300px]">
                                          <CircularProgress />
                                        </div>
                                      ) : !locationsWithCoords?.locations
                                          ?.length ? (
                                        <div className="text-center text-gray-500 py-10">
                                          No locations available.
                                        </div>
                                      ) : (
                                        <div>
                                          <ProductStoreMapping
                                            CampaignDetails={
                                              locationsWithCoords
                                            }
                                            showToggles={showToggles}
                                            activeProduct={activeProduct}
                                            onVendorViewModeChange={
                                              setVendorViewMode
                                            }
                                            allVendors={allVendorsList}
                                            approvedVendors={
                                              approvedVendorsList
                                            }
                                          />

                                          {/* Accordion Section - Conditionally render based on vendorViewMode */}
                                          <div className="col-span-12 mt-4 bg-white p-6 rounded-lg shadow">
                                            {vendorViewMode === "all" && (
                                              <CityAccordion
                                                data={locationsWithCoords}
                                                productType={activeProduct}
                                                showDropdown={true}
                                                showVendors={true}
                                                onTotalAreaChange={
                                                  handleTotalAreaChange
                                                }
                                                formData={formData}
                                                externalVendorsList={
                                                  allVendorsList
                                                }
                                              />
                                            )}

                                            {vendorViewMode === "approved" && (
                                              <StateAccordion
                                                data={locationsWithCoords}
                                                productType={activeProduct}
                                                showDropdown={true}
                                                showVendors={true}
                                                onTotalAreaChange={
                                                  handleTotalAreaChange
                                                }
                                                formData={formData}
                                                externalVendorsList={
                                                  approvedVendorsList
                                                }
                                              />
                                            )}

                                            {!vendorViewMode && (
                                              <CityAccordion
                                                data={locationsWithCoords}
                                                productType={activeProduct}
                                                showDropdown={true}
                                                showVendors={true}
                                                onTotalAreaChange={
                                                  handleTotalAreaChange
                                                }
                                                formData={formData}
                                                externalVendorsList={
                                                  allVendorsList
                                                }
                                              />
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </DialogContent>
                                  </Dialog>

                                  <div className=" bg-white m-6 p-10 flex justify-between items-center rounded-lg shadow ">
                                    <div className="mb-2">
                                      <ServiceNeeded
                                        operation={operation}
                                        formData={formData}
                                        value={ele}
                                        activeProduct={activeProduct}
                                        onChange={(updatedValue) => {
                                          const updatedProducts = [
                                            ...formData.products,
                                          ];

                                          let newServices =
                                            updatedValue.servicesNeeded;

                                          if (
                                            newServices.includes("Printing") ||
                                            newServices.includes("Fabrication")
                                          ) {
                                            newServices = newServices.filter(
                                              (s) => s !== "Painting",
                                            );
                                          }

                                          updatedProducts[index] = {
                                            ...ele,
                                            servicesNeeded: newServices,
                                          };

                                          setFormData({
                                            ...formData,
                                            products: updatedProducts,
                                          });
                                          setProductErrors((prev) =>
                                            prev.map((ele) => {
                                              if (
                                                ele?.productType ==
                                                activeProduct
                                              ) {
                                                return {
                                                  ...ele,
                                                  servicesNeeded: false,
                                                };
                                              }
                                            }),
                                          );
                                        }}
                                        error={Boolean(
                                          productErrors.find(
                                            (err) =>
                                              err?.productType ===
                                                activeProduct &&
                                              err?.servicesNeeded,
                                          ),
                                        )}
                                      />
                                      {productErrors.find(
                                        (err) =>
                                          err?.productType === activeProduct &&
                                          err?.servicesNeeded,
                                      ) && (
                                        <FormHelperText
                                          className="text-[var(--error-color)] text-[12px] -mt-3 ml-3"
                                          sx={{
                                            color: "var(--error-color)",
                                            marginTop: 1,
                                            marginLeft: 1.5,
                                          }}
                                        >
                                          {
                                            productErrors.find(
                                              (err) =>
                                                err?.productType ===
                                                  activeProduct &&
                                                err?.servicesNeeded,
                                            )?.servicesNeeded
                                          }
                                        </FormHelperText>
                                      )}
                                    </div>
                                    <div className="mb-2 w-[400px] flex  gap-3 ">
                                      {!(formData.products || []).find(
                                        (ele) =>
                                          ele.productType == activeProduct,
                                      )?.fabricationReport == "" && (
                                        <div className="group border border-gray-300 rounded-2xl mt-2 bg-white p-3 w-[220px] shadow-sm hover:shadow-md transition-all duration-200 hover:scale-[1.02] cursor-pointer">
                                          <h3 className="text-sm font-semibold text-gray-700 mb-1">
                                            Fabrication Report
                                          </h3>

                                          <p
                                            className="text-blue-500 text-sm font-medium flex items-center gap-1 group-hover:underline"
                                            onClick={() =>
                                              handleOpenReport(
                                                (formData.products || []).find(
                                                  (ele) =>
                                                    ele.productType ==
                                                    activeProduct,
                                                )?.fabricationReport,
                                              )
                                            }
                                          >
                                            Click to View →
                                          </p>
                                        </div>
                                      )}
                                      {!(formData.products || []).find(
                                        (ele) =>
                                          ele.productType == activeProduct,
                                      )?.printingReport == "" && (
                                        <div
                                          className="group border border-gray-300 rounded-2xl mt-2 bg-white p-3 w-[220px] shadow-sm hover:shadow-md transition-all duration-200 hover:scale-[1.02] cursor-pointer"
                                          onClick={() =>
                                            handleOpenReport(
                                              (formData.products || []).find(
                                                (ele) =>
                                                  ele.productType ==
                                                  activeProduct,
                                              )?.printingReport,
                                            )
                                          }
                                        >
                                          <h3 className="text-sm font-semibold text-gray-700 mb-1">
                                            Printing Report
                                          </h3>

                                          <p className="text-blue-500 text-sm font-medium flex items-center gap-1 group-hover:underline">
                                            Click to View →
                                          </p>
                                        </div>
                                      )}
                                      {!(formData.products || []).find(
                                        (ele) =>
                                          ele.productType == activeProduct,
                                      )?.paintingReport == "" && (
                                        <div
                                          className="group border border-gray-300 rounded-2xl mt-2 bg-white p-3 w-[220px] shadow-sm hover:shadow-md transition-all duration-200 hover:scale-[1.02] cursor-pointer"
                                          onClick={() =>
                                            handleOpenReport(
                                              (formData.products || []).find(
                                                (ele) =>
                                                  ele.productType ==
                                                  activeProduct,
                                              )?.paintingReport,
                                            )
                                          }
                                        >
                                          <h3 className="text-sm font-semibold text-gray-700 mb-1">
                                            Painting Report
                                          </h3>

                                          <p className="text-blue-500 text-sm font-medium flex items-center gap-1 group-hover:underline">
                                            Click to View →
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                    {
                                      <div>
                                        <Modal
                                          open={isReportModalOpen}
                                          onClose={handelReportModal}
                                          sx={{
                                            height: "full",
                                            width: "full",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            padding: "10px",
                                          }}
                                        >
                                          <iframe
                                            src={reportUrl}
                                            width="700"
                                            height="700"
                                            className="border rounded"
                                          />
                                        </Modal>
                                      </div>
                                    }
                                  </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-12 gap-6 m-6">
                                  <div className="col-span-12 md:col-span-12 bg-white p-10 rounded-lg shadow">
                                    <h3 className="text-gray-400 font-bold mb-6">
                                      MACHINE DATA
                                    </h3>

                                    {(formData.products || [])?.find(
                                      (ele) =>
                                        ele.productType === activeProduct,
                                    )?.servicesNeeded &&
                                      !(formData.products || [])
                                        .find(
                                          (ele) =>
                                            ele.productType === activeProduct,
                                        )
                                        .servicesNeeded.some((service) =>
                                          [
                                            "Painting",
                                            "Fabrication",
                                            "Printing",
                                          ].includes(service),
                                        ) && (
                                        <span className="text-[18px] font-semibold">
                                          Please select at least one service
                                          from these: Fabrication, Printing,
                                          Painting
                                        </span>
                                      )}

                                    {(formData.products || [])
                                      ?.find(
                                        (ele, index) =>
                                          ele.productType == activeProduct,
                                      )
                                      ?.servicesNeeded?.find(
                                        (ele) => ele == "Printing",
                                      ) && (
                                      <>
                                        <div className="">
                                          <div className="flex justify-between items-center py-3 w-full bg-[#e0edf4] px-3 rounded-t-lg mb-3">
                                            <div>
                                              <h2 className="font-[600]">
                                                Printing Machine Required
                                              </h2>
                                            </div>
                                            {operation != "view" && (
                                              <button
                                                className="btn flex items-center gap-2 rounded-lg shadow-lg text-white px-4 py-2 bg-[var(--primary-color)]"
                                                onClick={() =>
                                                  MachineModalOpen()
                                                }
                                              >
                                                <PlusIcon
                                                  color="white"
                                                  size="14px"
                                                />{" "}
                                                Add Machine
                                              </button>
                                            )}
                                          </div>
                                          <div className=" flex flex-col mx-4 mb-3 ">
                                            {formData?.products
                                              ?.find(
                                                (m) =>
                                                  m.productType ===
                                                  activeProduct,
                                              )
                                              ?.machinesNeededForPrinting?.map(
                                                (machine, i) => {
                                                  return (
                                                    <div
                                                      key={i}
                                                      className="mt-4 shadow-md rounded-lg px-10 py-2 border"
                                                    >
                                                      <div className="flex items-center justify-between ">
                                                        <label className="font-semibold">{`${machine.type} `}</label>

                                                        {operation !=
                                                          "view" && (
                                                          <IconButton
                                                            onClick={() =>
                                                              handleDeleteMachineSelection(
                                                                "machinesNeededForPrinting",
                                                                activeProduct,

                                                                machine.type,
                                                              )
                                                            }
                                                          >
                                                            <Delete
                                                              sx={{
                                                                color:
                                                                  "var(--error-color)",
                                                              }}
                                                            />
                                                          </IconButton>
                                                        )}
                                                      </div>
                                                      <div className="border w-full  my-1 rounded-lg" />

                                                      <PrintingMachineDetails
                                                        machine={machine}
                                                        handleInputChangeMachineDetails={
                                                          handleInputChangeMachineDetails
                                                        }
                                                        activeProduct={
                                                          activeProduct
                                                        }
                                                        handleDeleteMachineSelection={
                                                          handleDeleteMachineSelection
                                                        }
                                                        formData={formData}
                                                        operation={operation}
                                                        categoryLabels={
                                                          categoryLabels
                                                        }
                                                        handleInputChange={
                                                          handleInputChange
                                                        }
                                                      />
                                                    </div>
                                                  );

                                                  return null;
                                                },
                                              )}
                                          </div>
                                        </div>
                                      </>
                                    )}

                                    {/* // Fabrication Machines */}

                                    {(formData.products || [])
                                      .find(
                                        (ele) =>
                                          ele?.productType == activeProduct,
                                      )
                                      ?.servicesNeeded?.includes(
                                        "Fabrication",
                                      ) && (
                                      <>
                                        <div>
                                          <div className="flex justify-between items-center py-3 w-full bg-[#e0edf4] px-3 rounded-t-lg">
                                            <div>
                                              <h2 className="font-[600]">
                                                Fabrication Machine Required
                                              </h2>
                                            </div>
                                            {operation != "view" && (
                                              <button
                                                className="btn flex items-center gap-2 rounded-lg shadow-lg text-white px-4 py-2 bg-[var(--primary-color)]"
                                                onClick={() =>
                                                  handleFabMachineModalOpen()
                                                }
                                              >
                                                <PlusIcon
                                                  color="white"
                                                  size="14px"
                                                />{" "}
                                                Add Machine
                                              </button>
                                            )}
                                            {
                                              <Modal
                                                open={isFabOpen}
                                                onClose={handleCloseFabModal}
                                              >
                                                <Box
                                                  sx={{
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform:
                                                      "translate(-50%, -50%)",
                                                    width: 400, // Adjust width as needed
                                                    bgcolor: "white", // Background color
                                                    boxShadow: 24, // Adds shadow
                                                    borderRadius: "8px", // Rounded corners
                                                  }}
                                                >
                                                  <div className="border w-full flex justify-between items-center bg-blue-400  p-3 rounded-lg">
                                                    <Typography
                                                      variant="h6"
                                                      component="h2"
                                                      sx={{ color: "white" }}
                                                    >
                                                      Select Fabrication
                                                      Machines
                                                    </Typography>
                                                    <IconButton
                                                      onClick={
                                                        handleCloseFabModal
                                                      }
                                                      sx={{ color: "white" }}
                                                    >
                                                      <Close />
                                                    </IconButton>
                                                  </div>
                                                  <FormControl
                                                    fullWidth
                                                    sx={{
                                                      marginTop: "0.5rem",
                                                      marginBottom: "7px",
                                                      borderRadius: 2,
                                                      padding: "16px",
                                                    }}
                                                  >
                                                    <FormGroup>
                                                      {fabMachine?.map(
                                                        (machine, i) => (
                                                          <FormControlLabel
                                                            key={i}
                                                            control={
                                                              <Checkbox
                                                                checked={
                                                                  (
                                                                    formData.products ||
                                                                    []
                                                                  )
                                                                    ?.find(
                                                                      (p) =>
                                                                        p.productType ===
                                                                        activeProduct,
                                                                    )
                                                                    ?.machinesNeededForFabrication?.find(
                                                                      (m) =>
                                                                        m.type ===
                                                                        machine.type,
                                                                    )
                                                                    ?.checked ||
                                                                  false
                                                                }
                                                                onChange={() =>
                                                                  handlePrintMachineSelection(
                                                                    activeProduct,
                                                                    machine.type,
                                                                    "machinesNeededForFabrication",
                                                                  )
                                                                }
                                                              />
                                                            }
                                                            label={
                                                              <span className="">
                                                                {machine.type}
                                                              </span>
                                                            }
                                                          />
                                                        ),
                                                      )}
                                                    </FormGroup>
                                                  </FormControl>
                                                </Box>
                                              </Modal>
                                            }
                                          </div>

                                          <div className=" flex flex-col mx-4 ">
                                            {formData?.products
                                              ?.find(
                                                (m) =>
                                                  m.productType ===
                                                  activeProduct,
                                              )
                                              ?.machinesNeededForFabrication?.map(
                                                (machine, i) => {
                                                  return (
                                                    <div
                                                      key={i}
                                                      className="mt-4 shadow-md rounded-lg px-10 py-2 border mx-4"
                                                    >
                                                      <div className="flex justify-between items-center ">
                                                        <label className="font-semibold">
                                                          {machine?.type || ""}
                                                        </label>
                                                        {operation !=
                                                          "view" && (
                                                          <IconButton
                                                            onClick={() =>
                                                              handleDeleteMachineSelection(
                                                                "machinesNeededForFabrication",
                                                                activeProduct,

                                                                machine.type,
                                                              )
                                                            }
                                                          >
                                                            <Delete
                                                              sx={{
                                                                color:
                                                                  "var(--error-color)",
                                                              }}
                                                            />
                                                          </IconButton>
                                                        )}
                                                      </div>
                                                      <div className="border w-full  my-1 rounded-lg" />
                                                      <FabricationMachinesDetails
                                                        machine={machine}
                                                        handleInputChangeMachineDetails={
                                                          handleInputChangeMachineDetails
                                                        }
                                                        activeProduct={
                                                          activeProduct
                                                        }
                                                        operation={operation}
                                                        formData={formData}
                                                        categoryLabels={
                                                          categoryLabels
                                                        }
                                                        handleInputChange={
                                                          handleInputChange
                                                        }
                                                        index={index}
                                                      />
                                                    </div>
                                                  );
                                                },
                                              )}
                                          </div>
                                          <div className="border w-full my-4" />
                                        </div>
                                      </>
                                    )}

                                    {(formData.products || [])
                                      .find(
                                        (ele) =>
                                          ele?.productType == activeProduct,
                                      )
                                      ?.servicesNeeded?.includes(
                                        "Printing",
                                      ) && (
                                      <div>
                                        <div className="flex justify-between items-center py-3 w-full bg-[#e0edf4] px-3 rounded-t-lg">
                                          <div>
                                            <h2 className="font-[600]">
                                              Painting Machine Required
                                            </h2>
                                          </div>
                                          <FormControl
                                            size="small"
                                            sx={{ width: "50px" }}
                                          >
                                            {operation != "view" ? (
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    disabled={
                                                      operation === "view"
                                                    }
                                                    checked={
                                                      (
                                                        formData.products || []
                                                      ).find(
                                                        (product) =>
                                                          product.productType ===
                                                          activeProduct,
                                                      )
                                                        ?.machineNeededForPainting ||
                                                      false
                                                    }
                                                    onChange={(e) => {
                                                      const checked =
                                                        e.target.checked; // true/false
                                                      setFormData((prev) => ({
                                                        ...prev,
                                                        products:
                                                          prev.products.map(
                                                            (ele) => {
                                                              if (
                                                                ele.productType ===
                                                                activeProduct
                                                              ) {
                                                                return {
                                                                  ...ele,
                                                                  machineNeededForPainting:
                                                                    checked,
                                                                };
                                                              }
                                                              return ele;
                                                            },
                                                          ),
                                                      }));
                                                    }}
                                                  />
                                                }
                                                label=""
                                              />
                                            ) : (formData.products || []).find(
                                                (product) =>
                                                  product.productType ===
                                                  activeProduct,
                                              )?.machineNeededForPainting ? (
                                              <CheckCircleIcon
                                                sx={{ color: "green" }}
                                              />
                                            ) : (
                                              <CancelIcon
                                                sx={{ color: "red" }}
                                              />
                                            )}
                                          </FormControl>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>

              <Snackbar
                open={snackbar.open}
                autoHideDuration={5000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                <Alert
                  onClose={handleSnackbarClose}
                  severity={snackbar.severity}
                  sx={{
                    backgroundColor:
                      snackbar.severity === "success" ? "green" : "black",
                    color: "white",
                  }}
                >
                  {snackbar.message}
                </Alert>
              </Snackbar>

              {isModalOpen && (
                <ClientOnboarding
                  isModalOpen={isModalOpen}
                  setIsModalOpen={handleClientCloseModal}
                  fetchOrganizationList={fetchOrganizationList}
                  typeofComponent="Enquiryform"
                />
              )}
            </div>
          </Grid>
        </div>
      </DialogContent>
      <DialogActions className="flex justify-end w-full">
        <div className="w-30">
          <GlobalButton
            variant="secondary"
            size="medium"
            onClick={() => setRfpGenerate(false)}
          >
            {`Close`}
          </GlobalButton>
        </div>

        <div>
          {operation != "view" && (
            <GlobalButton
              type="submit"
              variant="primary"
              size="medium"
              disabled={isLoading}
              onClick={(e) => {
                setSaveButtonClicked(true);
                handleSubmit(e);
              }}
            >
              {operation === "edit" ? "Update" : "SUBMIT"}
            </GlobalButton>
          )}
          {
            <Modal open={open} onClose={handleClose}>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-4 rounded shadow-md max-w-[90vw] max-h-[90vh] overflow-auto">
                <div className="flex justify-between items-center mb-2">
                  <h2 className="text-lg font-semibold">Document Preview</h2>
                  <IconButton onClick={handleCloseModal}>
                    <CloseIcon />
                  </IconButton>
                </div>
                {selectedDoc ? (
                  selectedDoc.endsWith(".pdf") ? (
                    <iframe
                      src={selectedDoc}
                      width="400px"
                      height="500px"
                      style={{ border: "1px solid #ccc" }}
                    />
                  ) : selectedDoc.match(/\.(jpg|jpeg|png)$/i) ? (
                    <img
                      src={selectedDoc}
                      alt="Preview"
                      className="max-h-[600px] max-w-full object-contain mx-auto"
                    />
                  ) : (
                    <div className="text-center">
                      <p>Preview not available for this file type.</p>
                      <a
                        href={selectedDoc}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                      >
                        Open File
                      </a>
                    </div>
                  )
                ) : null}
              </div>
            </Modal>
          }
          <GlobalSnackbar
            snackbar={snackbar}
            handleClose={handleSnackbarClose}
          />
        </div>

        {
          <Modal open={isPrintOpen} onClose={handleCloseMachineBox}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400, // Adjust width as needed
                bgcolor: "white", // Background color
                boxShadow: 24, // Adds shadow
                borderRadius: "8px", // Rounded corners
              }}
            >
              <div className="border w-full flex justify-between items-center bg-blue-400  p-3 rounded-lg">
                <Typography variant="h6" component="h2" sx={{ color: "white" }}>
                  Select Printing Machines
                </Typography>
                <IconButton
                  onClick={handleCloseMachineBox}
                  sx={{ color: "white" }}
                >
                  <Close />
                </IconButton>
              </div>
              <FormControl
                fullWidth
                sx={{
                  marginTop: "0.5rem",
                  marginBottom: "7px",
                  borderRadius: 2,
                  padding: "16px",
                }}
              >
                <FormGroup>
                  {printMachine?.map((machine, i) => (
                    <FormControlLabel
                      key={i}
                      control={
                        <Checkbox
                          checked={
                            (formData.products || [])
                              ?.find((p) => p.productType === activeProduct)
                              ?.machinesNeededForPrinting?.find(
                                (m) => m.type === machine.type,
                              )?.checked || false
                          }
                          onChange={() =>
                            handlePrintMachineSelection(
                              activeProduct,
                              machine.type,
                              "machinesNeededForPrinting",
                            )
                          }
                        />
                      }
                      label={<span>{machine.type}</span>}
                    />
                  ))}
                </FormGroup>
              </FormControl>
            </Box>
          </Modal>
        }
      </DialogActions>
      {isReportsModal && (
        <Modal open={isReportsModal} onClose={handleCloseMachineBox}>
          <div
            className="h-[600px] w-full overflow-scroll flex justify-center items-start border border-1 border-blue-700 m-4
          "
          >
            <ReportsMainModal
              formData={formData}
              operation={operation}
              enquiryId={enquiryId}
              isRfpSerial={isRfpSerial}
              setFormData={setFormData}
              setReportsModal={setReportsModal}
              setRfpGenerate={setRfpGenerate}
              getRfpList={getRfpList}
              adminPortalView={adminPortalView}
            />
          </div>
        </Modal>
      )}
    </Dialog>
  );
};
const fabMachine = [
  { type: "Welding Machine" },
  { type: "Paint Compressor Machine" },
  { type: "CNC Router Machine" },
  { type: "Acrylic Laser Cutting Machine" },
  { type: "Channel Letter Bending Machine" },
];

const categoryLabels = {
  subCategory: "Sub Category",
  ampereOfMachine: "Ampere Of Machine",
  controllerSetting: "Controller Setting",
  ageOfMachine: "Age Of Machine",
  powerOfMachine: "Power Of Machine",
  lengthFoot: "Length (Ft.)",
  breadthFoot: "Breadth (Ft.)",
};

export default EnquiryModal;
let getMapping = (machine) => {
  if (machine === "CNC Router Machine") return lengthWidthMapping;
  if (machine === "Acrylic Laser Cutting Machine") return AcrylicWidthMapping;
  if (machine === "Channel Letter Bending Machine")
    return channelLetterWidthMapping;
  return {};
};
let lengthWidthMapping = {
  8: "4",
  10: "5",
  12: "5",
};
let AcrylicWidthMapping = {
  2: "3",
  3: "4",
  8: "4",
};

let channelLetterWidthMapping = {
  5: "3",
  4: "3",
  3: "2",
};
